import { render, staticRenderFns } from "./copyLabel.vue?vue&type=template&id=b13d3fac&scoped=true"
import script from "./copyLabel.vue?vue&type=script&lang=js"
export * from "./copyLabel.vue?vue&type=script&lang=js"
import style0 from "./copyLabel.vue?vue&type=style&index=0&id=b13d3fac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13d3fac",
  null
  
)

export default component.exports